import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import "../../styles/productFilters-styles.scss"
import FeatherIcon from 'feather-icons-react';
import SortProductTypesView from './Includes/SortProductTypesView'
import { ERROR_WHILE_FETCHING_PRODUCTFILTERS } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { toast } from 'react-toastify'
import { getProductFilters, updateProductFilters } from 'utlis/Apis/ProductFilters_API'
import { ERROR_WHILE_UPDATING_PRODUCTFILTERS } from 'utlis/AppMessages/AppMessages'
import LoadingSkeleton from 'components/Multipliers/Pages/BrandMultiplier/Includes/LoadingSkeleton'

import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'


function SortProductFilters(props) {
    // props
    const { authState } = props

    const [productFilters, setProductFilters] = useState([])
    const [loading, setLoading] = useState(false)

    // store url
    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        setLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getProductFilters(headers).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setProductFilters(arr => [...resData.data])
            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_PRODUCTFILTERS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getProductFilters `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                }
            })
        })

    }, [authState])

    const updateProductFilters_ = (productFilters_) => {
        setProductFilters(arr => [...productFilters_])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        updateProductFilters(headers, { filterlist: productFilters_ }).then(res => {
            const resData = res.data
            if (resData && resData.error) {
                toast.dismiss(
                    setLoading(true),
                );
                toast.error(ERROR_WHILE_UPDATING_PRODUCTFILTERS, {
                    autoClose: 3000,
                    onClose: () => {
                        setLoading(false)
                    }
                })
            }
        })

    }

    return (
        <section id="app-product-filters" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-product-filters">
                    <div className="app-header-wrapper mb-3">
                        <div className="back-button-wrapper mb-2">
                            <Link to={storeUrl + "/settings/product-filters"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                                <FeatherIcon
                                    icon="arrow-left"
                                    size="14"
                                    className="icon me-1" />
                                <span>Back</span>
                            </Link>
                        </div>
                        <p className="app-heading text-capitalize">Sort product filters</p>
                    </div>

                    <Row className="product-filter-left-content">
                        <Col lg={3} md={12}>
                            <p className="product-filter-desc">
                                Sort product filters
                            </p>
                        </Col>

                        <Col lg={9} md={12} className="product-filter-right-content">
                            {loading ? <LoadingSkeleton /> : <SortProductTypesView
                                productFilters={productFilters}
                                setProductFilters={updateProductFilters_}
                                loading={loading}
                            />}
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(SortProductFilters)